module.exports = __webpack_public_path__ + "img/27.83712957.jpg";